import type { Dictionary } from './en'

export const ko = {
  nav: { features: '기능', pricing: '가격', faq: '자주 묻는 질문', account: '내 계정', signIn: '로그인' },
  hero: {
    title: 'Mac을 위한 Alt-Tab',
    tagline: 'macOS는 앱을 전환합니다. AppSwitch는 ⌥Tab으로 창을 전환합니다. 같은 앱에서 연 세 개의 문서까지, 모든 창이 대상입니다.',
    download: 'Mac용 다운로드', seePricing: '가격 보기',
    note: '무료 · macOS 15 이상 · Apple 실리콘 및 Intel',
    hint: '⌥를 누른 채 Tab, 손을 떼면 전환됩니다',
  },
  features: {
    heading: '창을 스무 개씩 열어 두는 사람을 위해',
    sub: '⌥Tab 한 번이면 전부 펼쳐집니다. 손을 떼면 그곳입니다.',
    items: [
      { title: '앱이 아니라 창 단위로', body: 'macOS의 전환기는 앱 사이를 오갑니다. AppSwitch는 창 사이를 오갑니다. 같은 앱에서 연 세 개의 문서도 포함합니다.' },
      { title: '키보드 우선', body: '⌥Tab으로 앞으로, ⌥⇧Tab으로 뒤로, 화살표 키로 격자 안을 이동. ⌥에서 손을 떼면 선택한 창이 앞으로 나옵니다.' },
      { title: '포커스를 빼앗지 않음', body: '실제로 선택하기 전까지 원래 앱이 활성 상태로 남습니다. AppSwitch는 메뉴 막대에 머물며 Dock에 아이콘을 두지 않습니다.' },
      { title: '실시간 미리보기', body: '일반적인 앱 아이콘 대신 각 창의 실제 내용이 보입니다. 최소화한 창도 전환기에 그대로 나타납니다.' },
    ],
  },
  pricing: {
    heading: '한 번 사면, 계속 내 것.',
    sub: '전환기 자체는 무료이며 완전판입니다. 체험판도, 기능을 덜어낸 판도 아닙니다. Pro는 라이선스가 필요한 두 기능을 더합니다.',
    free: '무료', pro: 'Pro', ribbon: '1회 구매',
    freePrice: '₩0', once: '1회',
    freeSub: '⌘Tab을 그만 쓰기에 충분한 모든 것.',
    proSub: '구독 없음. 자동 갱신도 없습니다.',
    freeList: ['⌥Tab으로 여는 완전한 창 전환기', '키보드와 마우스 조작', '격자 보기와 목록 보기', '메뉴 막대 앱, Dock 아이콘 없음'],
    proList: ['무료 버전의 모든 것', '모든 창의 실시간 미리보기', '전환기에 표시되는 최소화한 창', '라이선스당 Mac 두 대'],
    download: '다운로드', buy: 'AppSwitch Pro 구매', buyBusy: '결제 창을 여는 중…',
    freeFoot: '계정 불필요. 카드 불필요. 기한 없음.',
  },
  faq: {
    heading: '자주 묻는 질문',
    items: [
      { q: '왜 손쉬운 사용 권한이 필요한가요?', a: '다른 앱보다 먼저 ⌥Tab을 가로채고, 창 목록을 만들고, 하나를 앞으로 가져오려면 macOS에서는 이 방법뿐입니다. 이 권한 없이는 앱이 전혀 작동하지 않습니다. 시스템 설정에서 직접 허용하고 언제든 취소할 수 있습니다.' },
      { q: '구독인가요?', a: '아닙니다. AppSwitch Pro는 1회 구매입니다. 자동 갱신도 추가 청구도 없으며, 현재 주 버전의 업데이트가 포함됩니다.' },
      { q: 'Mac 몇 대에서 쓸 수 있나요?', a: '라이선스당 두 대입니다. 계정 페이지나 앱에서 언제든 자리를 비울 수 있으므로 기기 변경 때문에 문의할 일은 없습니다.' },
      { q: '제 창 제목이 어딘가로 전송되나요?', a: '아닙니다. 창 내용도, 제목도, 키 입력도 Mac을 벗어나지 않습니다. 앱이 보내는 유일한 네트워크 요청은 라이선스 확인이며, Pro를 구매한 경우에만 해당합니다. 무료 버전은 네트워크를 전혀 쓰지 않습니다.' },
      { q: '어떤 macOS 버전을 지원하나요?', a: 'macOS 15 이상, Apple 실리콘과 Intel 모두 지원합니다.' },
    ],
  },
  listMode: {
    heading: '창을 보는 두 가지 방식',
    sub: '메뉴 막대에서, 또는 전환기가 열린 상태에서 「,」 키로 전환합니다.',
    grid: { title: '격자 보기, 미리보기 포함', body: '실제 내용의 축소판. 창을 그 안의 내용으로 구별하는 분께 알맞습니다.' },
    list: { title: '목록 보기, 전체 제목', body: '각 창의 제목 전체가 한 줄에 들어가는 조밀한 단일 열. 터미널이 스무 개일 때, 이름이 끝부분만 다른 파일에 알맞습니다.' },
  },

  footer: { terms: '이용 약관', privacy: '개인정보 처리방침' },
  consent: {
    text: '어떤 페이지가 유용한지 파악하기 위해 Google 애널리틱스를 사용합니다. 동의하지 않으면 아무것도 측정하지 않습니다. 자세한 내용은',
    privacyLink: '개인정보 처리방침', accept: '동의', decline: '거부',
  },
} satisfies Dictionary
